// extracted by mini-css-extract-plugin
export default {"backButton":"_dcbb4827","translucentWhite":"_fbda2ac2","backButtonDisabled":"_d4dd8d57"};